import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetIsStateReset } from '../stateHistory/stateHistorySlice';

export default function useClearStateResetFlag() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetIsStateReset());
  })
}
